export default "__VITE_ASSET__DJI2SrHl__"